'use client';

import {
  FetchTermsOfServiceRequest,
  FetchTermsOfServiceResponse,
} from '@trucksmarter/shared';
import Endpoint from '@lib/api/endpoints';
import useFetchResource from '@lib/api/client/resources/useFetchResource';

export default function useFetchTermsOfServiceCopy(
  tosCopyRequest: FetchTermsOfServiceRequest,
) {
  const {
    data,
    mutate: _,
    ...requestState
  } = useFetchResource<FetchTermsOfServiceRequest, FetchTermsOfServiceResponse>(
    Endpoint.FetchTermsOfService,
    tosCopyRequest,
  );

  return {
    data,
    ...requestState,
  };
}
